// To be separated into different files, add types and mocks
import { type HttpResponsePayload, createHttpEndpoint } from '../../utils'

export interface PostOrderEstimatedCommission {
  amount: number
  currency: string
}

export interface PostOrderPayload {
  id: number
  price: number
  currency: string
  estimatedCommission: PostOrderEstimatedCommission
}

export type PostOrderResponse = HttpResponsePayload<PostOrderPayload>

/**
 * Create BuyBack order
 *
 * @see {@link https://devportal.backmarket.io/catalog/default/api/buyback-bm-api/definition#tag/Customer/operation/sourcingNewOrder}
 */
export const postOrder = createHttpEndpoint<PostOrderResponse>({
  method: 'POST',
  operationId: 'swapCreateOrder',
  path: '/bm/sourcing/order/new',
})
